<app-perfil-shell
  [showGreeting]="false"
  [showBubbles]="true"
  [showSecurityBanner]="false"
  [skipFooterCms]="true"
  [sectionViewport]="true"
>
  <div class="perfil-ofertas">
    <div class="perfil-ofertas__chrome">
      <div class="perfil-ofertas__heading">
        <button
          type="button"
          class="perfil-ofertas__back"
          [attr.aria-label]="copy.atrasAria"
          (click)="onAtras()"
        >
          <img
            src="assets/img/perfil/icon-arrow.svg"
            alt=""
            width="24"
            height="24"
          />
        </button>
        <h1 class="perfil-ofertas__title">{{ copy.titulo }}</h1>
      </div>
    </div>

    @if (!loading && !error) {
      <div class="perfil-ofertas__pinned">
        <p class="perfil-ofertas__intro">{{ intro }}</p>
        <div
          class="perfil-ofertas__filtros"
          [class.perfil-ofertas__filtros--on]="filtrosInteractivos"
          [attr.aria-disabled]="filtrosInteractivos ? null : true"
        >
            <div class="perfil-ofertas-filtro perfil-ofertas-filtro--monto">
              <p class="perfil-ofertas-filtro__title">
                <span class="perfil-ofertas-filtro__title-label">{{ copy.filtroMonto }}</span>
                {{ ' ' }}
                <span class="perfil-ofertas-filtro__title-range">{{ labelMontoFiltro }}</span>
              </p>
              <div class="perfil-ofertas-filtro__ticks">
                @for (tick of ticksMonto; track tick; let i = $index) {
                  <button
                    type="button"
                    class="perfil-ofertas-filtro__tick"
                    [class.perfil-ofertas-filtro__tick--on]="
                      tickActivo(i, ticksMonto.length, 'monto')
                    "
                    [disabled]="!filtrosInteractivos"
                    (click)="onFiltroMonto(tick)"
                  >
                    {{ labelTickMonto(tick) }}
                  </button>
                }
              </div>
              <div class="perfil-ofertas-filtro__track" aria-hidden="true">
                @if (fillWidth(montoFill) > 0) {
                  <span
                    class="perfil-ofertas-filtro__fill"
                    [style.left.%]="montoFill.start"
                    [style.width.%]="fillWidth(montoFill)"
                  ></span>
                }
                @for (tick of ticksMonto; track tick; let i = $index) {
                  <span
                    class="perfil-ofertas-filtro__dot"
                    [class.perfil-ofertas-filtro__dot--on]="
                      dotEnRango(tickPct(i, ticksMonto.length), montoFill)
                    "
                    [style.left.%]="tickPct(i, ticksMonto.length)"
                  ></span>
                }
                @if (muestraRangoMonto) {
                  <img
                    class="perfil-ofertas-filtro__handle"
                    [src]="assetHandle"
                    width="22"
                    height="22"
                    alt=""
                    [style.left.%]="0"
                  />
                }
                <img
                  class="perfil-ofertas-filtro__handle"
                  [src]="assetHandle"
                  width="22"
                  height="22"
                  alt=""
                  [style.left.%]="montoHandlePct"
                />
              </div>
            </div>

            <div class="perfil-ofertas-filtro">
              <p class="perfil-ofertas-filtro__title">
                <span class="perfil-ofertas-filtro__title-label">{{ copy.filtroTasa }}</span>
                {{ ' ' }}
                <span class="perfil-ofertas-filtro__title-range">{{ labelTasaFiltro }}</span>
              </p>
              <div class="perfil-ofertas-filtro__ticks">
                @for (tick of ticksTasa; track tick; let i = $index) {
                  <button
                    type="button"
                    class="perfil-ofertas-filtro__tick"
                    [class.perfil-ofertas-filtro__tick--on]="
                      tickActivo(i, ticksTasa.length, 'tasa')
                    "
                    [disabled]="!filtrosInteractivos"
                    (click)="onFiltroTasa(tick)"
                  >
                    {{ labelTickTasa(tick) }}
                  </button>
                }
              </div>
              <div class="perfil-ofertas-filtro__track" aria-hidden="true">
                @if (fillWidth(tasaFill) > 0) {
                  <span
                    class="perfil-ofertas-filtro__fill"
                    [style.left.%]="tasaFill.start"
                    [style.width.%]="fillWidth(tasaFill)"
                  ></span>
                }
                @for (tick of ticksTasa; track tick; let i = $index) {
                  <span
                    class="perfil-ofertas-filtro__dot"
                    [class.perfil-ofertas-filtro__dot--on]="
                      dotEnRango(tickPct(i, ticksTasa.length), tasaFill)
                    "
                    [style.left.%]="tickPct(i, ticksTasa.length)"
                  ></span>
                }
                @if (muestraRangoTasa) {
                  <img
                    class="perfil-ofertas-filtro__handle"
                    [src]="assetHandle"
                    width="22"
                    height="22"
                    alt=""
                    [style.left.%]="0"
                  />
                }
                <img
                  class="perfil-ofertas-filtro__handle"
                  [src]="assetHandle"
                  width="22"
                  height="22"
                  alt=""
                  [style.left.%]="tasaHandlePct"
                />
              </div>
            </div>
        </div>
      </div>
    }

    <div
      class="perfil-ofertas__body"
      [class.perfil-ofertas__body--lista]="esLista"
      [class.perfil-ofertas__body--comparar-3]="esLista && seleccionadas.length >= 3"
    >
      @if (loading) {
        <p class="perfil-ofertas__state">Cargando ofertas…</p>
      } @else if (error) {
        <p class="perfil-ofertas__state perfil-ofertas__state--error">
          {{ copy.errorCarga }}
        </p>
      } @else {
        <div class="perfil-ofertas__col">
          @if (esLista || esUnaOferta) {
            <div class="perfil-ofertas__toolbar">
              <p class="perfil-ofertas__resultados-label">{{ labelResultados }}</p>
              <span class="perfil-ofertas__resultados-line" aria-hidden="true"></span>
              @if (esLista) {
                <label class="perfil-ofertas__ordenar">
                  <select
                    id="btn-ofertas-ordenar"
                    class="perfil-ofertas__ordenar-select"
                    [attr.aria-label]="copy.ordenarPor"
                    [value]="orden"
                    (change)="onOrden($any($event.target).value)"
                  >
                    <option value="">{{ copy.ordenarPor }}</option>
                    @for (op of ordenes; track op.id) {
                      <option [value]="op.id">{{ op.label }}</option>
                    }
                  </select>
                </label>
              }
            </div>
          }

          <div class="perfil-ofertas__scroll">
            <div class="perfil-ofertas__scroll-inner">
          @if (esUnaOferta && oferta) {
            <article class="perfil-ofertas-ficha">
              <header class="perfil-ofertas-ficha__top">
                <div class="perfil-ofertas-ficha__aliado">
                  @if (oferta.urlLogo) {
                    <img
                      class="perfil-ofertas-ficha__logo-img"
                      [src]="oferta.urlLogo"
                      [alt]="oferta.nombreIntermediario"
                      width="40"
                      height="40"
                    />
                  } @else {
                    <span class="perfil-ofertas-ficha__logo" aria-hidden="true">{{
                      iniciales(oferta.nombreIntermediario)
                    }}</span>
                  }
                  <div>
                    <p class="perfil-ofertas-ficha__nombre">
                      {{ oferta.nombreIntermediario }}
                    </p>
                    <p class="perfil-ofertas-ficha__plazo-copy">
                      {{ copy.pagaloEn(oferta.plazo) }}
                    </p>
                  </div>
                </div>
                <div class="perfil-ofertas-ficha__aside">
                  <div class="perfil-ofertas-ficha__highlights">
                    <span class="perfil-ofertas-ficha__monto-top">{{
                      dinero(oferta.monto)
                    }}</span>
                    <span class="perfil-ofertas-ficha__tasa-top">{{
                      copy.tasaEa(oferta.tasa)
                    }}</span>
                  </div>
                  @if (esBancoldex(oferta)) {
                    <div
                      class="perfil-ofertas-ficha__bx"
                      tabindex="0"
                      [attr.aria-label]="
                        copy.creditoBancoldex + '. ' + copy.ofertaDineroBancoldex
                      "
                    >
                      <img
                        class="perfil-ofertas-ficha__bx-icon"
                        [src]="assetBancoldex"
                        alt=""
                        width="16"
                        height="21"
                      />
                      <span class="perfil-ofertas-ficha__bx-copy" aria-hidden="true">
                        <span class="perfil-ofertas-ficha__bx-title">{{
                          copy.creditoBancoldex
                        }}</span>
                        <span class="perfil-ofertas-ficha__bx-sub">{{
                          copy.ofertaDineroBancoldex
                        }}</span>
                      </span>
                    </div>
                  }
                </div>
              </header>

              <ng-container
                *ngTemplateOutlet="
                  detalleOferta;
                  context: { $implicit: oferta, bx: esBancoldex(oferta) }
                "
              ></ng-container>

              <button
                type="button"
                class="perfil-ofertas-ficha__cta"
                id="btn-ofertas-tomar"
                (click)="onTomarOferta(oferta, 'btn-ofertas-tomar')"
              >
                {{ copy.tomarOferta }}
                <span
                  class="material-icons perfil-ofertas-ficha__cta-icon"
                  aria-hidden="true"
                >check_circle_outline</span>
              </button>
            </article>
          }

          @if (esLista) {
            <div class="perfil-ofertas__lista">
                @for (item of visibles; track item.idPropuesta) {
                  <article
                    class="perfil-ofertas-card"
                    [class.perfil-ofertas-card--open]="esExpandida(item)"
                    [class.perfil-ofertas-card--sel]="estaSeleccionada(item)"
                  >
                    <div class="perfil-ofertas-card__oferta">
                    <div class="perfil-ofertas-card__head">
                    <button
                      type="button"
                      class="perfil-ofertas-card__row"
                      [attr.aria-expanded]="esExpandida(item)"
                      (click)="toggleExpand(item)"
                    >
                      <div class="perfil-ofertas-ficha__aliado">
                        @if (item.urlLogo) {
                          <img
                            class="perfil-ofertas-ficha__logo-img"
                            [src]="item.urlLogo"
                            [alt]="item.nombreIntermediario"
                            width="40"
                            height="40"
                          />
                        } @else {
                          <span class="perfil-ofertas-ficha__logo" aria-hidden="true">{{
                            iniciales(item.nombreIntermediario)
                          }}</span>
                        }
                        <div>
                          <p class="perfil-ofertas-ficha__nombre">
                            {{ item.nombreIntermediario }}
                          </p>
                          <p class="perfil-ofertas-ficha__plazo-copy">
                            {{ copy.pagaloEn(item.plazo) }}
                          </p>
                        </div>
                      </div>
                      <div class="perfil-ofertas-card__meta">
                        <div class="perfil-ofertas-ficha__highlights">
                          <span class="perfil-ofertas-ficha__monto-top">{{
                            dinero(item.monto)
                          }}</span>
                          <span class="perfil-ofertas-ficha__tasa-top">{{
                            copy.tasaEa(item.tasa)
                          }}</span>
                        </div>
                        <span
                          class="material-icons perfil-ofertas-card__chevron"
                          [class.perfil-ofertas-card__chevron--open]="esExpandida(item)"
                          aria-hidden="true"
                        >keyboard_arrow_down</span>
                      </div>
                    </button>
                    </div>
                    <div
                      class="perfil-ofertas-card__detalle-wrap"
                      [class.perfil-ofertas-card__detalle-wrap--open]="esExpandida(item)"
                      [attr.inert]="esExpandida(item) ? null : true"
                    >
                      <div class="perfil-ofertas-card__detalle">
                        <ng-container
                          *ngTemplateOutlet="
                            detalleOferta;
                            context: { $implicit: item, bx: esBancoldex(item) }
                          "
                        ></ng-container>
                        <div class="perfil-ofertas-card__actions">
                          <button
                            type="button"
                            class="perfil-ofertas-card__btn perfil-ofertas-card__btn--ghost"
                            [class.perfil-ofertas-card__btn--on]="estaSeleccionada(item)"
                            [attr.aria-pressed]="estaSeleccionada(item)"
                            [attr.aria-label]="
                              estaSeleccionada(item)
                                ? copy.quitarCompararAria
                                : copy.seleccionarAria
                            "
                            [disabled]="compararBloqueado(item)"
                            (click)="onComparar(item, $event)"
                          >
                            {{ copy.comparar }}
                          </button>
                          <button
                            type="button"
                            class="perfil-ofertas-card__btn perfil-ofertas-card__btn--solid"
                            (click)="onTomarOferta(item, 'btn-ofertas-tomar-lista'); $event.stopPropagation()"
                          >
                            {{ copy.tomarOferta }}
                          </button>
                        </div>
                      </div>
                    </div>
                    </div>
                  </article>
                }
            </div>
          }

          @if (esLista || esUnaOferta) {
            <button
              type="button"
              class="perfil-ofertas__rechazar"
              id="btn-ofertas-rechazar"
              (click)="onRechazarAbrir()"
            >
              {{ copy.rechazarOfertas }}
            </button>
          }

          @if (!esLista && !esUnaOferta) {
            <p class="perfil-ofertas__state">{{ copy.vacioFiltro }}</p>
          }

          @if (mostrarTodasVisible) {
            <button
              type="button"
              class="perfil-ofertas__mostrar-todas"
              id="btn-ofertas-mostrar-todas"
              (click)="onMostrarTodas()"
            >
              {{ copy.mostrarTodas }}
            </button>
          }
            </div>
          </div>
        </div>

        @if (esLista) {
          <aside
            class="perfil-ofertas-comparar"
            [class.perfil-ofertas-comparar--filled]="seleccionadas.length > 0"
            [attr.aria-label]="copy.compararTitulo"
          >
            @if (seleccionadas.length === 0) {
              <div class="perfil-ofertas-comparar__info">
                <div class="perfil-ofertas-comparar__title-block">
                  <span class="perfil-ofertas-comparar__icon-wrap">
                    <img
                      class="perfil-ofertas-comparar__icon"
                      [src]="assetComparar"
                      alt=""
                      width="34"
                      height="34"
                    />
                  </span>
                  <p class="perfil-ofertas-comparar__title">{{ copy.compararTitulo }}</p>
                </div>
                <p class="perfil-ofertas-comparar__copy">{{ copy.compararEmpty }}</p>
              </div>
            } @else {
              <div class="perfil-ofertas-comparar__board">
                <div class="perfil-ofertas-comparar__keys">
                  <div class="perfil-ofertas-comparar__keys-head" aria-hidden="true"></div>
                  <ul class="perfil-ofertas-comparar__keys-list">
                    <li>{{ copy.compararMonto }}</li>
                    <li>{{ copy.garantias }}</li>
                    <li>{{ copy.desembolso }}</li>
                    <li>{{ copy.tasa }}</li>
                    <li>{{ copy.cuotaAprox }}</li>
                    <li>{{ copy.plazo }}</li>
                    <li>{{ copy.pago }}</li>
                    <li>{{ copy.lineaBancoldex }}</li>
                  </ul>
                </div>
                <div class="perfil-ofertas-comparar__cols-scroll">
                <div
                  class="perfil-ofertas-comparar__cols"
                  [class.perfil-ofertas-comparar__cols--multi]="seleccionadas.length > 1"
                  [style.--n]="seleccionadas.length"
                >
                  @for (item of seleccionadas; track item.idPropuesta) {
                    <article class="perfil-ofertas-comparar__col">
                      <header class="perfil-ofertas-comparar__col-head">
                        @if (item.urlLogo) {
                          <img
                            class="perfil-ofertas-comparar__col-logo"
                            [src]="item.urlLogo"
                            [alt]="item.nombreIntermediario"
                            width="32"
                            height="32"
                          />
                        } @else {
                          <span class="perfil-ofertas-comparar__col-logo" aria-hidden="true">{{
                            iniciales(item.nombreIntermediario)
                          }}</span>
                        }
                        <p class="perfil-ofertas-comparar__col-name">
                          {{ item.nombreIntermediario }}
                        </p>
                        <button
                          type="button"
                          class="perfil-ofertas-comparar__col-close"
                          [attr.aria-label]="copy.quitarCompararAria"
                          (click)="quitarComparar(item.idPropuesta)"
                        >
                          <span class="material-icons" aria-hidden="true">close</span>
                        </button>
                      </header>
                      <div class="perfil-ofertas-comparar__col-vals">
                        <span class="perfil-ofertas-comparar__val perfil-ofertas-comparar__val--teal">{{
                          dinero(item.monto)
                        }}</span>
                        <span class="perfil-ofertas-comparar__val perfil-ofertas-comparar__val--red">{{
                          dinero(-totalGarantias(item))
                        }}</span>
                        <span class="perfil-ofertas-comparar__val">{{
                          dinero(item.desembolsoAproximado)
                        }}</span>
                        <span class="perfil-ofertas-comparar__val">{{
                          copy.tasaEa(item.tasa)
                        }}</span>
                        <span class="perfil-ofertas-comparar__val">{{ dinero(item.cuota) }}</span>
                        <span class="perfil-ofertas-comparar__val">{{
                          copy.plazoMeses(item.plazo)
                        }}</span>
                        <span class="perfil-ofertas-comparar__val">{{
                          item.nombrePeriodicidad
                        }}</span>
                        <span
                          class="material-icons perfil-ofertas-comparar__check"
                          aria-hidden="true"
                        >{{ esBancoldex(item) ? 'check' : 'close' }}</span>
                      </div>
                      <button
                        type="button"
                        class="perfil-ofertas-comparar__tomar"
                        (click)="onTomarOferta(item, 'btn-ofertas-tomar-comparar')"
                      >
                        {{ copy.tomarOferta }}
                      </button>
                    </article>
                  }
                </div>
                </div>
              </div>
            }
          </aside>
        }
      }
    </div>

    @if (esLista) {
      <button
        type="button"
        class="perfil-ofertas__fab"
        [class.perfil-ofertas__fab--on]="seleccionadas.length >= 2"
        id="btn-ofertas-comparar"
        [disabled]="seleccionadas.length < 2"
        (click)="onFabComparar()"
      >
        Comparar
        <span class="perfil-ofertas__fab-n">({{ seleccionadas.length }})</span>
      </button>
    }
  </div>
</app-perfil-shell>

<app-perfil-ofertas-modales
  [open]="modal"
  [diasRestantes]="diasRestantes"
  [oferta]="ofertaActiva"
  [seleccionadas]="seleccionadas"
  [par078]="par078"
  [par079]="par079"
  [idSolicitud]="idSolicitud"
  [motivos]="motivos"
  [enviando]="enviando"
  (closed)="onCerrarModal()"
  (salir)="onSalirHome()"
  (revisar)="onCerrarModal()"
  (tomarSiguiente)="onTomarSiguiente()"
  (tomarConfirmar)="onTomarConfirmar()"
  (rechazar)="onRechazarConfirmar($event)"
  (quitarComparar)="quitarComparar($event)"
  (tomarDesdeComparar)="onTomarOferta($event)"
></app-perfil-ofertas-modales>

<ng-template #detalleOferta let-oferta let-bx="bx">
  <div class="perfil-ofertas-ficha__grid">
    <div>
      <span class="perfil-ofertas-ficha__k">{{ copy.montoAprobado }}</span>
      <span class="perfil-ofertas-ficha__v perfil-ofertas-ficha__v--teal">{{
        dinero(oferta.monto)
      }}</span>
    </div>
    <div>
      <span class="perfil-ofertas-ficha__k">
        {{ copy.garantias }}
        @if (tieneGarantias(oferta)) {
          <button
            type="button"
            class="perfil-ofertas-ficha__hint"
            [attr.aria-label]="copy.modalGarantiasTitulo"
            (click)="onGarantias(oferta, $event)"
          >
            <span class="material-icons" aria-hidden="true">help_outline</span>
          </button>
        }
      </span>
      <span class="perfil-ofertas-ficha__v perfil-ofertas-ficha__v--red">{{
        dinero(-totalGarantias(oferta))
      }}</span>
    </div>
    <div>
      <span class="perfil-ofertas-ficha__k">{{ copy.desembolso }}</span>
      <span class="perfil-ofertas-ficha__v">{{
        dinero(oferta.desembolsoAproximado)
      }}</span>
    </div>
    <div>
      <span class="perfil-ofertas-ficha__k">{{ copy.tasa }}</span>
      <span class="perfil-ofertas-ficha__v">{{
        copy.tasaEa(oferta.tasa)
      }}</span>
    </div>
    <div>
      <span class="perfil-ofertas-ficha__k">{{ copy.cuotaAprox }}</span>
      <span class="perfil-ofertas-ficha__v">{{
        dinero(oferta.cuota)
      }}</span>
    </div>
    <div>
      <span class="perfil-ofertas-ficha__k">{{ copy.plazo }}</span>
      <span class="perfil-ofertas-ficha__v">{{
        copy.plazoMeses(oferta.plazo)
      }}</span>
    </div>
    <div>
      <span class="perfil-ofertas-ficha__k">{{ copy.pago }}</span>
      <span class="perfil-ofertas-ficha__v">{{
        oferta.nombrePeriodicidad
      }}</span>
    </div>
    @if (bx) {
      <div class="perfil-ofertas-ficha__cell--bx">
        <div class="perfil-ofertas-card__bx" [attr.aria-label]="copy.creditoBancoldex">
          <img
            class="perfil-ofertas-card__bx-icon"
            [src]="assetBancoldex"
            alt=""
            width="16"
            height="21"
          />
          <span class="perfil-ofertas-card__bx-copy" aria-hidden="true">
            <span>{{ copy.creditoBancoldexL1 }}</span>
            <span>{{ copy.creditoBancoldexL2 }}</span>
          </span>
        </div>
      </div>
    }
    <div class="perfil-ofertas-ficha__cell--obs">
      <span class="perfil-ofertas-ficha__k">{{ copy.observaciones }}</span>
      <span class="perfil-ofertas-ficha__v">{{
        oferta.observacionesAprobador || '—'
      }}</span>
    </div>
  </div>
</ng-template>
